import { useEffect, useState } from "react";
import { useQueryClient } from "@tanstack/react-query";
import { KeyRound, Lock } from "lucide-react";
import { api, setToken, getToken, onUnauthorized, formatErr } from "@/lib/api";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";

function AccessPage({ onOk }) {
  const [code, setCode] = useState("");
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setErr("");
    try {
      const { data } = await api.post("/auth/login", { code });
      setToken(data.token);
      onOk();
    } catch (ex) {
      setErr(formatErr(ex.response?.data?.detail) || "Erreur de connexion");
      setCode("");
    }
    setBusy(false);
  };
  return (
    <div className="min-h-screen grid place-items-center bg-slate-100 dark:bg-slate-950 p-4" data-testid="access-page">
      <form onSubmit={submit} className="panel w-full max-w-sm p-6 space-y-4">
        <div className="flex items-center gap-2">
          <div className="h-9 w-9 rounded-[3px] bg-slate-900 dark:bg-slate-100 grid place-items-center"><Lock className="h-4 w-4 text-white dark:text-slate-900" /></div>
          <div><div className="font-display font-bold leading-tight">Radar Territorial</div><div className="overline">Accès protégé</div></div>
        </div>
        <label className="block text-xs text-slate-600 dark:text-slate-400">Code d'accès
          <Input data-testid="access-code-input" type="password" autoFocus autoComplete="current-password" value={code} onChange={(e) => setCode(e.target.value)} className="mt-1 h-9 font-mono" />
        </label>
        {err && <div data-testid="access-error" className="text-xs text-rose-700 dark:text-rose-400 border border-rose-200 dark:border-rose-900 bg-rose-50 dark:bg-rose-950/40 rounded-[3px] px-2 py-1.5">{err}</div>}
        <Button data-testid="access-submit" type="submit" className="w-full" disabled={!code || busy}><KeyRound className="h-4 w-4 mr-1.5" />Accéder</Button>
      </form>
    </div>
  );
}

export const AccessGate = ({ children }) => {
  const qc = useQueryClient();
  const [ok, setOk] = useState(null);
  useEffect(() => {
    onUnauthorized(() => { setToken(null); qc.clear(); setOk(false); });
    if (!getToken()) return setOk(false);
    api.get("/auth/status").then((r) => setOk(r.data.authorized)).catch(() => setOk(false));
  }, [qc]);
  if (ok === null) return <div className="min-h-screen grid place-items-center text-xs text-slate-400 font-mono">Vérification de l'accès…</div>;
  if (!ok) return <AccessPage onOk={() => setOk(true)} />;
  return children;
};
